import { Empty, Spin } from 'antd'
import Flex from 'components/Flex'
import Pagination from 'components/Pagination'
import {
  FlexWrap,
  RowNumberData,
  Wrapper,
} from 'components/TableStyles/TableContentStyles/TableContentStyles'
import { StyledTable } from 'components/TableStyles/TableStyles'
import DriveActonInfo from 'modules/Exp-Candidates/DriveTable/Actions/index'
import DriveStatus from 'modules/Exp-Candidates/DriveTable/DriveStatus/index'
import Drivefilter from 'modules/Exp-Candidates/DriveTable/Drivefilter/index'
import moment from 'moment'
import React from 'react'
import {
  DriveIDStyleAlignCenter,
  EmptyWrapper,
} from '../Components/Styles/style'

const UpcomingTable = ({
  listOfDrivesDetails,
  onPageChange,
  currentPage,
  searchValue,
  setSearchValue,
  driveRoles,
  setDriveRoles,
  driveMode,
  setDriveMode,
  driveStatus,
  setDrivestatus,
  filteApplied,
  isLoading,
  corporateStatus,
  onChangeSort,
  occurrence,
}) => {
  const getDriveDate = date => {
    let startDate = moment(date)

    return startDate.isValid() ? (
      <Flex>
        <RowNumberData>{startDate.format('DD/MM/YYYY')} &nbsp;</RowNumberData>
      </Flex>
    ) : (
      <>_</>
    )
  }

  const getNoData = () => {
    if (occurrence === 'UPCOMING') {
      return 'No upcoming drives found!'
    } else if (occurrence === 'PAST') {
      return 'No past drives found!'
    } else {
      return 'No ongoing drives found!'
    }
  }

  const columns = [
    {
      title: 'Drive ID',
      dataIndex: 'serialNo',
      sorter: true,
      key: 'id',
      align: 'center',
      sortDirections: ['ascend', 'descend'],
      render: (_, data) => (
        <DriveIDStyleAlignCenter>
          0{data?.drive?.serialNo}
        </DriveIDStyleAlignCenter>
      ),
      width: '13%',
    },
    {
      title: 'Roles',
      dataIndex: 'tittle',
      key: 'roles',
      render: (driveRoleMap, data) => {
        return (
          <FlexWrap alignCenter gap="8px">
            <RowNumberData>
              {data?.role?.tittle?.length > 16
                ? data?.role?.tittle?.substr(0, 16) + '...'
                : data?.role?.tittle}
            </RowNumberData>
          </FlexWrap>
        )
      },
      width: '15%',
    },

    {
      title: 'Drive Date',
      dataIndex: 'createdAt',
      sorter: true,
      key: 'startDate',
      sortDirections: ['ascend', 'descend'],
      render: (_, data) => getDriveDate(data?.createdAt),
      width: '20%',
    },
    {
      title: 'Status',
      dataIndex: 'corporateStatus',
      key: 'corporateStatus',
      align: 'center',
      sortDirections: ['ascend', 'descend'],
      render: (_, status) => (
        <DriveStatus status={status?.drive?.corporateStatus} />
      ),
      width: '9%',
    },
    {
      title: 'Action',
      dataIndex: 'id',
      key: 'id',
      sortDirections: ['ascend', 'descend'],
      render: (_, drive) => <DriveActonInfo drive={drive} />,
      width: '8%',
    },
  ]

  return (
    <Wrapper>
      <Drivefilter
        driveRoles={driveRoles}
        setDriveRoles={setDriveRoles}
        driveMode={driveMode}
        setDriveMode={setDriveMode}
        driveStatus={driveStatus}
        setDrivestatus={setDrivestatus}
        searchValue={searchValue}
        setSearchValue={setSearchValue}
        filteApplied={filteApplied}
        corporateStatus={corporateStatus}
        currentCount={
          listOfDrivesDetails?.count < 10
            ? listOfDrivesDetails?.count
            : listOfDrivesDetails?.currentPage * 10 -
              10 +
              listOfDrivesDetails?.list?.length
        }
        totalCount={listOfDrivesDetails?.count}
      />
      <StyledTable
        pagination={false}
        rowKey="id"
        columns={columns}
        dataSource={listOfDrivesDetails?.list || []}
        onChange={onChangeSort}
        locale={{
          emptyText: (
            <EmptyWrapper center isSpin={!isLoading}>
              {isLoading ? <Empty description={getNoData()} /> : <Spin />}
            </EmptyWrapper>
          ),
        }}
      />
      <Pagination
        onChange={onPageChange}
        totalPages={listOfDrivesDetails?.count}
        pageSize={10}
        current={currentPage}
      />
    </Wrapper>
  )
}

export default UpcomingTable
